export const apiUrl = process.env.REACT_APP_API_URL;

export const appUrl = process.env.REACT_APP_APP_URL;

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }